import React from 'react';
import PropTypes from 'prop-types';

// atoms
import Card from '../../atoms/card';
import Phone from '../../atoms/phone';

// styles
import './style.scss';

const PhoneList = ({ phones }) => {
  return (
    <Card className="phone-list">
      {phones.map(phone => (
        <Phone key={phone.number} number={phone.number} text={phone.text} />
      ))}
    </Card>
  );
};

PhoneList.propTypes = {
  phones: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string,
      text: PropTypes.string
    })
  ).isRequired
};

export default PhoneList;
